import axios from 'axios';

const getAllInsights = (insightSetId) => {
  return axios.get('/api/insights', {
    params: {insightSetId}
  });
};

const getAllInsightsOptim = (insightSetId, filteringInput, offset, limit, currentTab, changeTypeCount, isMyInsightsChecked, isNoVotesChecked) => {
  return axios.post('/api/insights/allInsights', {
    insightSetId,
    filteringInput,
    offset,
    limit,
    currentTab,
    changeTypeCount, 
    isMyInsightsChecked, 
    isNoVotesChecked
  });
};

const createInsight = (newInsight) => {
  return axios.post('/api/insights', newInsight);
};

const createMultipleInsights = (body) => {
  return axios.post('/api/insights/createMultipleInsights', body);
};

const editInsight = (updatedInsight, config) => {
  return axios.put('/api/insights', updatedInsight, config);
};

const deleteInsight = (insight, config) => {
  return axios.delete('/api/insights', {data: insight, ...config});
};

const editAuthorNotes = (authorNotes, config) => {
  return axios.put('/api/insights/author_note', authorNotes, config);
};

const addOrEditComment = (comment) => {
  return axios.post('/api/insights/add_or_edit_comment',comment);
};

const withdrawCommentById = (id) => {
  return axios.post('/api/insights/withdraw_vote',{
    id: id
  });
};

const getGoalProgress = (setId, config) => {
  return axios.get(`/api/goals/goal_progress/?setId=${setId}`, config);
};

const getAllSets = (config) => {
  return axios.get('/api/insights/insightSets', config);
};

const createSet = (set) => {
  return axios.post('/api/insights/insightSets', set);
};

const getSetById = (setId, config) => {
  return axios.get(`/api/insights/insightSets/${setId}`, config);
};

const editSet = (set) => {
  return axios.post('/api/insights/insightSets/', set);
};

const deleteSet = (setId, config) => {
  return axios.delete(`/api/insights/insightSets/${setId}`, config);
};

const predictInsights = (programs) => {
  return axios.post('/api/insights/generateInsights',  programs);
};

const createImplementationPlan = (selectedInsights) => {
  return axios.post('/api/insights/implementationPlan', selectedInsights);
};

export {
  getAllInsights,
  getAllInsightsOptim,
  createInsight,
  createMultipleInsights,
  editInsight,
  deleteInsight,
  addOrEditComment,
  withdrawCommentById,
  editAuthorNotes,
  getGoalProgress,
  getAllSets,
  createSet,
  getSetById,
  editSet,
  deleteSet,
  predictInsights,
  createImplementationPlan,
};
